






















































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import LineRegistButton from '../student/register/LineRegistButton.vue';
import PagesMixin from '../components/organisms/PagesMixin';
import SimpleCheckBox from '../components/inputs/SimpleCheckBox.vue';

@Component({ components: { LineRegistButton } })
export default class EntrancePage extends Mixins(PagesMixin) {
  is_check_kiyaku = false;

  studentLogin() {
    this.$router.push({ path: '/student-login-page?building=co01' });
  }

  mailRegist() {
    this.$router.push({ path: '/student-mail-register-page?building=co01' });
  }
  showKiyaku() {
    this.$router.push({ path: '/student-term-of-use-page?building=co01' });
  }
  checkedKiyaku() {
    this.is_check_kiyaku = true;
  }
}
